export const RequiredAstrisk = () => <span className={'required-asterisk'}>*</span>
